import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'admin-components/components';
import { useQuery } from '@apollo/client';
import { GET_MEALS } from 'store/queries';
import AgentPortalError from 'errors/AgentPortalError';
import { ACTION_CODES } from 'constants/errors';
import { regularMeal } from 'types/meals';

const GetMealsQuery = ({ reference, segmentId, children }) => {
  const { loading, data, error } = useQuery(GET_MEALS, {
    variables: { reference, segmentId },
    fetchPolicy: 'network-only'
  });

  if (loading) {
    return <Spinner />;
  }
  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: `/manage/bookings/${reference}`
    });
  }
  const { meals } = data;

  return children([...meals, regularMeal]);
};

GetMealsQuery.propTypes = {
  children: PropTypes.func.isRequired,
  reference: PropTypes.string.isRequired,
  segmentId: PropTypes.string.isRequired
};

export default GetMealsQuery;
